<template>
  <div id="app">
    <a-config-provider :locale="local">
      <component :is="layout" v-if="layout" />
      <keep-alive v-else :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </a-config-provider>
  </div>
</template>

<script>
import HomeLayout from '@/layout/HomeLayout'
import DefaultLayout from '@/layout/DefaultLayout'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
  components: { HomeLayout, DefaultLayout },

  data() {
    return {
      local: zhCN
    }
  },

  computed: {
    layout() {
      return this.$route.meta.layout
    },

    cachedViews() {
      return this.$store.state.cacheView.cachedViews
    },

    key() {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  min-width: $body-width;
}
</style>
